import { CoinUserJson } from '@xylabs/sdk-coin-js'
import { isAuthenticated, useAuthUser } from '@xylabs/sdk-coin-react'
import { useAsyncEffect } from '@xyo-network/sdk-xyo-react-js'
import { AxiosError } from 'axios'
import { useState } from 'react'

import { useApi } from '../../../Contexts'

const useUserInfo = (sanitize = false) => {
  const user = useAuthUser()
  const authenticated = isAuthenticated()
  const api = useApi(true)

  const [userInfo, setUserInfo] = useState<CoinUserJson>()
  const [error, setError] = useState<AxiosError>()
  const [refreshCount, setRefreshCount] = useState(0)

  useAsyncEffect(
    async (mounted) => {
      if (user && api && authenticated) {
        try {
          if (error) setError(undefined)
          const userInfo =
            refreshCount === 0
              ? sanitize
                ? await api.getUserSanitized()
                : await api.getUser()
              : sanitize
              ? await api.fetchUserSanitized()
              : await api.fetchUser()
          if (mounted()) {
            setUserInfo(userInfo)
          }
        } catch (ex) {
          const error = ex as AxiosError
          if (mounted()) {
            setError(error)
          }
        }
      }
    },
    [api, user, authenticated, sanitize, refreshCount]
  )

  const refreshUserInfo = () => {
    setUserInfo(undefined)
    setRefreshCount(refreshCount + 1)
  }

  return { error, refreshUserInfo, userInfo }
}

export default useUserInfo
